import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgImprovedDesk = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 21,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 10a.5.5 0 0 1 0 1H19l1 8h-1l-1-8h-6l-1 8h-1l1-8H9.5a.5.5 0 0 1 0-1h11ZM6 5a1 1 0 0 1 1 1v6a1 1 0 0 1 1 1v2H7v4H6v-4H2v4H1v-4H0v-2a1 1 0 0 1 1-1V6a1 1 0 0 1 1-1h4Zm1 8H1v1h6v-1ZM6 6H2v6h4V6Zm12-6v3h3v1h-3v3h-1V3.999L14 4V3l3-.001V0h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgImprovedDesk;